import Cookies from 'js-cookie'
import SHA256 from 'crypto-js/sha256'
import {useHttp, useRequest } from '../../utils/initInstance'
import { setUserCookie,  getUserCookie, clearAllCookie} from '../../utils/toolsfn'
import tools from '../../utils/tools'
import {toRaw,markRaw} from "vue";
const { $api } = useHttp()
const { confEnv } = require("../../../config")

    /**
    数据查找
    **/
    function treeFind(tree, cb, childrenkey) {
      for (const data of tree) {
        if (cb(data)) return data
        if (data[childrenkey || 'children']) {
          const res = treeFind(data[childrenkey || 'children'], cb)
          if (res) return res
        }
      }
      return null
  }

// 遍历树形结构
function treeFilter(tree, func, childrenkey) {
  // 使用map复制一下节点，避免修改到原树
  return tree
    .map(node => ({ ...node }))
    .map((node) => {
      if (node[childrenkey || 'children']) {
          node[childrenkey || 'children'] = node[childrenkey || 'children'] && treeFilter(node[childrenkey || 'children'], func)
      }
      return (
        func(node) || (node[childrenkey || 'children'] && node[childrenkey || 'children'].length)
      )
    })
}

function treeFindPath(tree, func, path = [], childrenkey) {
  if (!tree) return []
  for (const data of tree) {
    path.push({ path: data.path, title: data?.meta?.title })
    if (func(data)) return path
    if (data[childrenkey || 'children']) {
      const findChildren = treeFindPath(data[childrenkey || 'children'], func, path)
      if (findChildren.length) return findChildren
    }
    path.pop()
  }
  return []
  }
 const state = {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      title: process.env.portal === 'sp' ? '服务商运营后台' : '总部运营工作台'
    },
    plaformType: Cookies.get('plaformType') || 'main',
    selectList: [
      {
       value: 'composite',
       label: '东风Honda',
       disabled:false

      },
      {
         value: 'main',
         label: '东风honda售后',
         disabled: false
      },
      {
         value: 'shop',
         label: '信赖商城',
         disabled: false
      },
      {
         value: 'coupons',
         label: '电子券平台',
         disabled: true
      },
      {
         value: 'market',
         label: '营销平台',
         disabled: true
      }
    ],
    breakList: [],
    language: Cookies.get('language') || 'en',
    menuObject: {
        plaformType: 'composite',
        menuList: [],
        userData: getUserCookie() || {},
        treeMenuList: []
       }
  }

 const mutations = {
    TOGGLE_SIDEBAR: (state) => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    ADD_BREAK_OPTIONS(state, { actionType, crrutPageOptions, breakList }) { // 面包屑逻辑处理
       if (actionType === 'updateCrrutBreakStatus') {
        const OtherBreakList = breakList
        const isHasIndex = []
        const breakhasUpdate = state.breakList.map((it) => {
         const ishas = breakList.findIndex((its) => {
          return ((its.key && it.key && (its.key === it.key)) || its.title === it.title)
        })
           if (ishas !== -1) {
            isHasIndex.push(breakList[ishas])
             return {
                ...it,
                ...breakList[ishas]
             }
           }
           return it
        })
          // isHasIndex.forEach((element) => {
          // OtherBreakList.splice(element, 1)
          // })
          const leftBreadLists = OtherBreakList.filter((it) => {
            if (it.sortStatus === 'left') {
              const ishasOpt = isHasIndex.find(its => its.title === it.title || (its.key && it.key && (its.key === it.key)))
              if (!ishasOpt) {
                return true
              }
              return false
            }
            return false
          })
          const rightBreadLists = OtherBreakList.filter((it) => {
            if (it.sortStatus === 'right') {
              const ishasOpt = isHasIndex.find(its => its.title === it.title || (its.key && it.key && (its.key === it.key)))
               if (!ishasOpt) {
                return true
               }
               return false
            }
            return false
          })

          state.breakList = [...leftBreadLists, ...(state.breakList.length ? breakhasUpdate : crrutPageOptions), ...rightBreadLists]
        } else if (actionType === 'replaceCrrutBreakStatus') {
            const leftBreadList = breakList.filter(it => it.sortStatus === 'left') || []
            const rightBreadList = breakList.filter(it => it.sortStatus === 'right') || []
            state.breakList = [...leftBreadList, ...crrutPageOptions, ...rightBreadList]
        }
    },
    SetMenuRouter(state, 
      {
      plaformType,
      menuList,
      userData,
      treeMenuList
    }) {
        
        if(plaformType && Array.isArray(treeMenuList)) {
              state.menuObject = { 
                                plaformType,
                                menuList,
                                userData,
                                treeMenuList
                          }
           } else {
            state.menuObject = {
              plaformType: 'main',
              menuList: [],
              userData: {},
              treeMenuList: []
            }
        }
    },
    clearOutUser(state) {
      clearAllCookie()
      state.menuObject = {
        plaformType: state.menuObject.plaformType,
        menuList: [],
        userData: {},
        treeMenuList: []
      }
    }
  }

 const actions = {
    toggleSideBar ({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    clearUser({commit}) {
      commit('clearOutUser')
    },
    setLanguage ({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    // 面包屑逻辑处理
    addBreakOptions({ commit, state }, { crrutRoutePath, breakList }) {
      const crrutPath = crrutRoutePath // 当前页面路径
      const filterBreakList = breakList.map((it) => {
          if (!it.path) {
            it.path = '/breakPath' + parseInt(Math.random() * 1e10)
          }
          return it
      })
        // **当前页面导航面包屑***
         const crrutPageOptions = treeFindPath(this.state.permission.roleNavMenList, (node) => {
          if (node && node.path && node.meta.title) {
            return node.path === crrutPath
           }
         })

        const commbindPageOptions = crrutPageOptions.map((it) => {
               const isHasRouteOpt = Array.isArray(filterBreakList) ? filterBreakList.find(t => t.title === it.title) : undefined
               if (isHasRouteOpt) {
                const { path, ...isHasRoute } = isHasRouteOpt
                 return { ...it, show: true, ...isHasRoute }
               }
               return { ...it, show: true }
         })

        if (crrutPageOptions.length) {
          const ishasCrrutPageIndex = state.breakList.findIndex(it => it.path === crrutPath)
          if (ishasCrrutPageIndex !== -1) { // 存在当前面包屑路径
            commit('ADD_BREAK_OPTIONS', { // 更新面包屑
                 actionType: 'updateCrrutBreakStatus',
                 crrutPageOptions: commbindPageOptions,
                 breakList: [...(Array.isArray(filterBreakList)
                  ? filterBreakList
                  : [])]
            })
          } else { // 当前面包屑路径不存在
            commit('ADD_BREAK_OPTIONS', { // 替换面包屑
              actionType: 'replaceCrrutBreakStatus',
              crrutPageOptions: commbindPageOptions,
              breakList: [...(Array.isArray(filterBreakList)
              ? filterBreakList
              : [])]
            })
          }
        }
    },
    // 登录流程调用
    async getUserData({ commit, dispatch, state }, {userformData, platformType}) {
     try {
      const { data } = await useRequest($api.checkWorkNumber, userformData, {async: true})
      
        if(!data) {
          return new Promise((resolve, reject) => {
               useRequest($api.logindo, 
                { ...userformData,  
                  password: SHA256(userformData.password).toString()
                  
                }, 
                {
                    onSuccess: async (res) => {
                      console.log('userLogin///', res)
                   
                        if(res.data.errCode === '000000') {
                              if(process.env.NODE_ENV === 'development') {
                                setUserCookie(res.data.data)
                               }
                        const userParams = getUserCookie()
                        const {plaformType,  menuList, treeMenuList} = await dispatch('getAuthorMenu', { plaformType: (platformType || state.plaformType)})
                         
                        // /*
                        //   commit('SetMenuRouter', {
                        //     plaformType,
                        //     menuList: menuList,
                        //     userData:userParams, 
                        //     treeMenuList
                        //   }) 
                        //  */
                        
                        resolve({
                            type: 'other', 
                            userData:userParams, 
                            paraData:null,
                            plaform: {
                              plaformType,  
                              menuList
                            }
                          })
                         } else {
                       
                          resolve({
                            type: 'err', 
                            userData: {
                              errMsg: res?.data?.errMsg || '验证失败，请重试'
                            }, 
                            paraData:null,
                            plaform: {},
                            menuList: [],
                            treeMenuList: []
                          })
                      }
                    }
                })
                })
            } else {
                  const { type, userData,  paraData, authorUrl='' } = await dispatch('getParaAuthorUser', {source: 'para'})
                  return Promise.resolve({
                    type, 
                    userData,  
                    paraData,
                    authorUrl
                  })
               }
        } catch(e) {
            return Promise.reject(e)
        }
    },
     // 单点登录调用
    async getParaAuthorUser({ commit, dispatch, state }, options) {
           const { source } = options
            const userParams = getUserCookie()
            const { data, err, loading } = await useRequest('/honda-pc/para/getAuthorizeParam', {}, {
              async: true,
              method:'get',
             })
             if(data && Object.prototype.toString.call(data) === "[object Object]") {
              if( source && source === 'para') {
                const result = data // JSON.parse(data)
                const dpchttp = (process.env.NODE_ENV === 'production') ? 'https://sso.wdhac.com.cn'   : 'https://para.ngateway.com'
                const authorUrl = dpchttp + '/esc-sso/oauth2.0/authorize?response_type=' + result.data.responseType + '&client_id=' + result.data.clientId + '&redirect_uri=' + result.data.redirectUri
                   return Promise.resolve({
                        type: 'factory',
                        userData: userParams || {},
                        paraData: data,
                        authorUrl
                      })

                } else {
                  return Promise.resolve({
                    type: 'other',
                    userData: userParams || {},
                    paraData: null
                  })
                }
             } else {
              return Promise.resolve({
                type: 'other',
                userData:userParams || {},
                paraData: null
              })
             }
    },
    // 菜单权限调用
   async getAuthorMenu({ commit, dispatch, state }, {
    plaformType
    }) {
    const userParams = getUserCookie()
    const getAwaitRequest = new Map([
        ['main', async() => { // 东风honda售后权限调用
          const { data, err, loading } = await useRequest('/honda-pc/initMenu.do', {}, {
            method:'get',
           // async: true
          })

          if(!err && data && Object.prototype.toString.call(data) === "[object Object]") { 
            // 处理权限菜单逻辑
            const result = JSON.parse(data.data) || []
            const treeMenu = treeFilter(result, (node) => {
                  // 转换树形结构属性
                  const {
                    childId,
                    authChildMenuDTOList,
                    childMenuName,
                    childMenuUrl,
                    parentMenuName,
                    parentId,
                    iconClass
                  } = node
                  if (typeof parentId === "number" && parentId >= 0) {
                    return {
                      path: '',
                      routerType: 'main',
                      menuKey: useRequest.randomRange(6),
                      title: parentMenuName,
                      icon: iconClass,
                      menupid: parentId,
                      children: authChildMenuDTOList || [],
                    };
                  } else {
                    let options = {
                      path: /^[/]?http[s]?:\/\/.*/.test(childMenuUrl) ? childMenuUrl.replace(/^\/+/, '') : ('/angular' + (childMenuUrl || ('/' + useRequest.randomRange(6)))),
                      menuid: childId,
                      menuKey: useRequest.randomRange(6),
                      title: childMenuName,
                      children: authChildMenuDTOList || [],
                      routerType: 'main',
                    }
                    return options
                  }
            }, 'authChildMenuDTOList')

            return Promise.resolve({
              plaformType,
              menuList: result,
              treeMenuList:[].concat(treeMenu)
            })

          }
          return Promise.resolve({
            plaformType,
            menuList: [],
            treeMenuList: []
          })
        }],
        ['shop', async () => { // 商城权限调用

          const { data, err, loading } = await useRequest('/oauth-service/getMenuList', {
          }, {
            baseURL:  process.env.NODE_ENV === 'development' ? '/api' : '/authserve',
            method:'get',
            async: true
          })
          console.log('initMenuList000',  data) 
          if(!err && data && Object.prototype.toString.call(data) === "[object Object]") {
                  const initMenuList = new tools.CreateTree({
                    title: 'name',
                    path: 'url',
                    code: 'code',
                   // hidden: 'isMenu',
                    hideMenu:'isMenu',
                    menupid: 'pId',
                    menuid: 'id',
                    menuKey: 'id', // useRequest.randomRange(6),
                    icon: 'icon',
                    sort: 'sort',
                    pCode: 'pCode',
                    level: 'level',
                    status: 'status'
                  }, {
                    parentId: 'pCode',
                    childrenId: 'code',
                    rootId: 'ROOT',
                    JsonData: data.dataList
                  }).creatTre()
              console.log('initMenuList',  initMenuList) 
              return Promise.resolve({
                plaformType,
                menuList: data.dataList, // initMenuList
                treeMenuList: treeFilter(initMenuList, (node) => {
                    if(node.path) {
                          node.routerType = 'shop',
                          node.path = '/subShop' + node.path
                    }
                    return node
                })
              })
            
          }

          return Promise.resolve({
            plaformType,
            menuList: [],
            treeMenuList: []
          })
          
        }],
        ['composite', () => { // 组合模式菜单

        }
        ],
        ['coupons', () => { // 电子券调用
          
        }],
        ['market', () => { // 营销权限调用

        }]

    ])

    if(getAwaitRequest.get(plaformType) && typeof getAwaitRequest.get(plaformType) === "function") { 
      Cookies.set('plaformType', plaformType, { path: '/', domain: window.location.hostname});
      if(plaformType === 'composite') {
        const dataMainMenu = getAwaitRequest.get('main')
        const dataShopMenu = getAwaitRequest.get('shop')
        const { treeMenuList:mainMenu,  menuList:mainList } = await dataMainMenu()
        const { treeMenuList:shopMenu,  menuList:shopList } = await dataShopMenu()
     
        const menCopstionList = [
          {
            path: '/home',
            routerType: 'main',
            icon: "icon-list",
            menuKey: useRequest.randomRange(6),
            title: '首页',
            menupid: useRequest.randomRange(8),
            children: [],
          },
         {
          
            path: '',
            routerType: 'composite',
            menuKey: useRequest.randomRange(6),
            title: '售后',
            menupid: useRequest.randomRange(8),
            children: mainMenu,
        },
        {
          path: '',
          routerType: 'composite',
          menuKey: useRequest.randomRange(6),
          title: '商城',
          menupid: useRequest.randomRange(8),
          children: shopMenu,
        }
       ]

       commit('SetMenuRouter', {
        plaformType,
        menuList: [...mainList, shopList],
        userData:userParams, 
        treeMenuList:menCopstionList
       })
      return Promise.resolve({
        plaformType,
        menuList: [...mainList, shopList],
        treeMenuList: menCopstionList
       })
      } else {
        const dataMenu = getAwaitRequest.get(plaformType)
        const { plaformType: plaform, treeMenuList,  menuList } = await dataMenu()
        
        commit('SetMenuRouter', {
          plaformType,
          menuList: menuList,
          userData:userParams, 
          treeMenuList
         })
  
        
        return Promise.resolve({
          plaformType,
          menuList,
          treeMenuList
         })
      }
  
    }
    commit('SetMenuRouter', {
      plaformType,
      menuList: [],
      userData:userParams, 
      treeMenuList: []
     })
    return Promise.resolve({
      plaformType,
      menuList: [],
      treeMenuList: []
     })
    }
  }

 const getters = {
 }

  export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
  }